import { TouchableOpacity, View } from 'react-native';
import React, { useState } from 'react';
import LogoSVG from '~/assets/svgs/logo-web.svg';
import SmallLogoSVG from '~/assets/svgs/logo.svg';
import ArrowLeftSVG from '~/assets/svgs/arrow-left.svg';
import Text from '../Text';
import useHeader from '~/hooks/useHeader';
import FloatingMenu from '../Header/components/FloatingMenu';
import useAppNavigation from '~/hooks/useAppNavigation';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

const WebHeader = () => {
  const [height, setHeight] = useState(0);

  const { canBack, isLoggedIn, onGoBack, onPressLogin } = useHeader();
  const { navigate } = useAppNavigation();

  return (
    <View
      className="w-[100%] items-center bg-light-100"
      style={{ paddingBottom: height }}
    >
      <View
        className="bg-light-100 fixed container items-center justify-between py-5 flex-row border-b border-b-gray-100 px-2 md:px-6 xl:px-0 max-w-5xl"
        onLayout={(e) => setHeight(e.nativeEvent.layout.height)}
      >
        {canBack ? (
          <TouchableOpacity onPress={() => onGoBack()}>
            <ArrowLeftSVG />
          </TouchableOpacity>
        ) : (
          <View />
        )}

        <TouchableOpacity
          activeOpacity={1}
          onPress={() => navigate('MarisaServicos_Home')}
        >
          <>
            <View className="hidden sm:block">
              <LogoSVG />
            </View>

            <View className="block sm:hidden">
              <SmallLogoSVG />
            </View>
          </>
        </TouchableOpacity>
        {MarisaAppUtils.disableInsurance ? (
          <View />
        ) : (
          <>
            {isLoggedIn ? (
              <FloatingMenu />
            ) : (
              <TouchableOpacity onPress={onPressLogin}>
                <View className="py-2 px-4 bg-primary-600 rounded-3xl">
                  <Text className="text-white font-medium text-sm">Entrar</Text>
                </View>
              </TouchableOpacity>
            )}
          </>
        )}
      </View>
    </View>
  );
};

export default WebHeader;
